export default "__VITE_ASSET__26b53760__"